<template>
	<div id="pgination">
		<el-pagination
		  background
		  layout="prev, pager, next"
		  :total="count"
			@current-change="isclick">
		</el-pagination>
	</div>
</template>

<script>
	export default{
		name:'pgination',
		props:{
			count:{
				type:Number,
				default:0
			},
		},
		methods:{
			isclick(index){
				this.$emit('isindex',index)
			}
		}
	}
</script>

<style scoped>

</style>